import COPY_AI_REPORT_MUTATION from '@/entities/report/api/mutations/copyAiReport';
import { createClient } from '@/shared/api';
import type {
  CopyAiReportMutation,
  CopyAiReportMutationVariables,
} from '@/shared/api/generated/graphql';

export type CopyAiReportResult = {
  isSuccess: boolean;
  message: string;
};

// TODO(ts): typed as the CopyAiReportInput GraphQL input once its server-side shape is documented
/**
 * Copies an existing AI report onto another target. Runs the copyAiReport mutation and returns its field without inspecting the success flag.
 *
 * @param input - Mutation input naming the source and destination reports.
 * @returns A promise resolving to the copyAiReport result.
 */
const handleCopyAiReport = async (input: any) => {
  const client = await createClient();
  const result = await client.mutate<CopyAiReportMutation, CopyAiReportMutationVariables>({
    mutation: COPY_AI_REPORT_MUTATION,
    variables: {
      input,
    },
  });
  const { data } = result;
  const { copyAiReport } = data;
  return copyAiReport;
};

export default handleCopyAiReport;
